import React from "react";

export const Check = () => {
  return (
    <svg fill="none" viewBox="0 0 24 24">
      <path fill="#000" fill-rule="evenodd" d="M19.916 4.62595c.3447.22976.4378.69542.208 1.04006l-9 13.49999c-.1246.187-.3265.3082-.5501.3303-.2236.0222-.4453-.0571-.60423-.216l-6-6c-.29289-.2929-.29289-.7677 0-1.0606.29289-.2929.76777-.2929 1.06066 0l5.35307 5.3531L18.876 4.83396c.2297-.34464.6954-.43777 1.04-.20801Z" clip-rule="evenodd"/>
    </svg>
  )
}

export default Check
